
import TableList from "@components/templates/tablelist";
import { HttpGetBillRehandleList,HttpCreateByPrice } from "@/service/newbigaccount";
import { HttpGetAllPriceTemplate } from '@/service/tasks';
import { mapState, mapGetters } from "vuex";
import compIndex from './rehandleupdate'
import compCost from './rehandlecost'
import mixin from '../minxin'
export default {
    mixins: [TableList,mixin],
    components:{
        compIndex,
        compCost
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
            tempList:[],
        };
    },
    created(){
        HttpGetAllPriceTemplate().then(res=>{
            this.tempList = res.data.map(item=>{
                return {value: item.id, label: `${item.code}(${item.name})`}
            })
        })
    },
    methods: {
        ajaxRequest: HttpGetBillRehandleList,

        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.operate={
                        show: true,
                        title: "重处理",
                        width:500,
                        component: "compIndex",
                        activeids:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "rehandleCost":
                    this.operate = {
                        show: true,
                        alert: 'primary',
                        title: "重处理(指定报价)",
                        showDesc:false,
                        width:500,
                        component:'compCost',
                        showFooter:false,
                    }
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCusBillTypeList','getTransferHostWarehouse']),
        ToolsData(){
            return [
                {
                    name: "重处理",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "重处理(指定报价)",
                    operate: "rehandleCost",
                    theme: "info",
                },
            ]

        },
        SearchsData() {
            const dropStyle="width:auto;";
            return  [
                {
                    label: "重处理编号",
                    tag: 'vInput',
                    key: 'EQ_reprocessNo',
                    show:true,
                    props:{
                        dropStyle,
                    }
                },
                {
                    label: "客户",
                    tag: 'Select',
                    key: 'EQ_organizationId',
                    show:true,
                    options:this.getBillcusorgList,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "仓库",
                    tag: 'Select',
                    key: 'EQ_warehouseId',
                    show:true,
                    options:this.getTransferHostWarehouse,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "账单编号",
                    tag: 'Input',
                    key: 'EQ_billNo',
                },
                {
                    label: '费用类型',
                    tag: 'Select',
                    key: 'EQ_expenseCategoryType',
                    options: [
                        { value: 0, label: '作业费' },
                        { value: 1, label: '仓储费' },
                        { value: 3, label: '增值服务费' },
                    ],
                    props:{
                        filterable:true,
                    },
                },
                {
                    label: '单据类型',
                    tag: 'Select',
                    key: 'EQ_orderType',
                    options: this.getOrderList,
                    props:{
                        filterable:true,
                    },
                },
                {
                    label: '创建时间',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    style: "width:180px",
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                }
            ]
        },
        columns() {
            return  [
                {
                    title: '处理类型',
                    width: 110,
                    render:(h,{row})=>{
                        return <div>{row.type == 0 ? '按照账单':'按照指定报价'}</div>
                    }
                },
                {
                    title: '重处理编号',
                    key:'reprocessNo'
                },
                {
                    title: '客户/仓库',
                    render: (h, { row }) => {
                        let wareArr;
                        let nameArr=[];
                        if(row.warehouseId){
                            wareArr = row.warehouseId.split(',');
                            wareArr.map(item=>{
                                nameArr.push(this.findRenderLabel(this.getTransferHostWarehouse, item))
                            })
                        }
                        return <div>
                            <div>{this.findRenderLabel(this.getBillcusorgList, row.organizationId)}</div>
                            <div>{nameArr.join(',')||'--'}</div>
                        </div>
                    },
                },
                {
                    title: '费用类型/单据类型',
                    key: 'expenseCategoryType',
                    render: (h, { row }) => {
                        let tempArr;
                        let name1Arr=[];
                        if(row.orderType){
                            tempArr = row.orderType.split(',');
                            tempArr.map(item=>{
                                name1Arr.push(this.findRenderLabel(this.getOrderList, item))
                            })
                        }
                        return <div>
                            <div>{this.findRenderLabel(this.getCusBillTypeList, row.expenseCategoryType)}</div>
                            <div>{name1Arr.join(',')||'--'}</div>
                        </div>
                    },
                },
                {
                    title: '账单编号/报价模板',
                    key:'billNo',
                    render: (h, { row }) => {
                        
                        return <div>
                            <div>{row.billNo||'--'}</div>
                            <div>{this.findRenderLabel(this.tempList, row.billingPriceTemplateId)||'--'}</div>
                        </div>
                    },
                },
                {
                    title: '结算账期',
                    render: (h, { row }) => {
                        return <div>
                        <div>{row.startTime || '--'} '~' {row.endTime || '--'}</div>
                        </div>

                    },
                },
                {
                    title: '创建人',
                    render: (h, { row }) => {
                        return <div>
                        <div>{row.createdName || '--'}</div>
                        </div>

                    },
                },
                {
                    title: '创建时间',
                    key:'createdAt'
                },
            ];
        },

    },

};
